import { Component, OnInit } from '@angular/core';
import { ChartDataSets, ChartType, ChartOptions } from 'chart.js';
import { Label } from 'ng2-charts';
import { ReportService } from 'src/app/services/report.service';
import { Subscription } from 'rxjs';
import { StorageMap } from '@ngx-pwa/local-storage';

@Component({
  selector: 'app-report-track-voters',
  templateUrl: './report-track-voters.component.html',
  styleUrls: ['./report-track-voters.component.css']
})
export class ReportTrackVotersComponent implements OnInit {

  constructor(private storage: StorageMap, private reportService: ReportService) { }
  dataSubscription: Subscription;
  labels: string[];

  barChartOptions: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{}], yAxes: [{}] },
  };
  tracks: Label[] = [];
  barChartType: ChartType = 'bar';
  barChartLegend = true;
  barChartPlugins = [];
  barChartData: ChartDataSets[] = [];
  hasData = false;

  ngOnInit(): void {
    this.dataSubscription = this.storage.watch('selectedOpenId', { type: 'string' })
      .subscribe((openId) => {
        const openIdInt = parseInt(openId, 10);
        if (!isNaN(openIdInt)){
          this.getTracksParticipantVsVoters(openIdInt);
        }
      });
  }

  getTracksParticipantVsVoters(openSpaceId) {
    this.reportService.getTracksParticipantVsVoters(openSpaceId)
      .subscribe(data => {
        if (data && data.Reports.length !== 0){
          this.tracks = data.Reports[0].labels;
          this.barChartData = data.Reports[0].data;
          this.hasData = true;
        }
      },
      error => {
        console.error(error);
      });
  }
}

